import { render, staticRenderFns } from "./uploadGuide.vue?vue&type=template&id=054c1539&scoped=true"
import script from "./uploadGuide.vue?vue&type=script&lang=js"
export * from "./uploadGuide.vue?vue&type=script&lang=js"
import style0 from "./uploadGuide.vue?vue&type=style&index=0&id=054c1539&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c1539",
  null
  
)

export default component.exports